import { Text, Group } from "@mantine/core";
import { ReactNode } from "react";

interface Props {
    headerText: string;
    additionalContent?: ReactNode;
}

export function DetailSectionHeader({ headerText, additionalContent }: Props) {
    return (
        <div className="details-section-header">
            <Group position="apart" w="100%">
                <Text className="details-section-header-text">{headerText}</Text>
                {additionalContent && (
                    <div>
                        {additionalContent}
                    </div>
                )}
            </Group>
        </div>
    );
}
